<template>
  <div>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div style="padding-bottom: 10px;width:100px;">
      <Button type="primary" long icon="ios-search" @click="onClickSearch">检索条件</Button>
    </div>
    <Table
      id="responseTable"
      ref="table"
      :width="tWidth"
      :data="showData"
      :columns="showColumns"
      stripe
      border
      highlight-row
      @on-current-change="onTableCurrentChange"
    ></Table>
    <Row style="padding-bottom: 10px;margin-top:10px;">
      <Col span="4" style="padding-right: 10px;">
        <Button type="success" long @click="onClickInsert">添加反馈</Button>
      </Col>
      <Col span="4" style="padding-right: 10px;">
        <Button type="warning" long @click="onClickUpdate">处理反馈</Button>
      </Col>
      <Col span="4" style="padding-right: 10px;">
        <Button type="error" long @click="onClickDelete">删除反馈</Button>
      </Col>
      <Col span="11">
        <Page
          style="text-align:right"
          :current="currentPage"
          :total="dataCount"
          :page-size="pageSize"
          show-sizer
          show-total
          @on-change="changePage"
          @on-page-size-change="changePageSize"
        ></Page>
      </Col>
    </Row>
    <!-- 模态框search -->
    <Modal v-model="isShowModal.search" :mask-closable="false" width="380">
      <p slot="header" style="color:#2d8cf0;text-align:center">
        <Icon type="ios-search" />
        <span>检索条件</span>
      </p>
      <Form ref="formSearch" :label-width="100" :model="formSearch">
        <FormItem label="反馈类型：">
          <Select v-model="formSearch.responseType" clearable placeholder="请输入反馈类型...">
            <Option value="申述">申述</Option>
            <Option value="咨询">咨询</Option>
            <Option value="建议">建议</Option>
            <Option value="报修">报修</Option>
          </Select>
        </FormItem>
        <FormItem label="设备编号：">
          <Input v-model="formSearch.responseMeterId" placeholder="请输入设备编号..."></Input>
        </FormItem>
        <FormItem label="用户姓名：">
          <Input v-model="formSearch.responseCustomerName" placeholder="请输入用户姓名..."></Input>
        </FormItem>
        <FormItem label="手机号：">
          <Input v-model="formSearch.responseCustomerPhone" placeholder="请输入手机号..."></Input>
        </FormItem>
        <FormItem label="地址：">
          <Input v-model="formSearch.responseCustomerAddress" placeholder="请输入地址..."></Input>
        </FormItem>
        <FormItem label="反馈内容：">
          <Input
            v-model="formSearch.responseContent"
            placeholder="请输入反馈内容..."
            type="textarea"
            :autosize="{minRows: 2,maxRows: 5}"
          ></Input>
        </FormItem>
        <FormItem label="反馈时间：">
          <Tooltip
            transfer
            placement="top"
            :disabled="formSearch.responseCreateTimeRange == undefined || formSearch.responseCreateTimeRange[0] == ''"
            max-width="200"
          >
            <div
              slot="content"
              v-if="formSearch.responseCreateTimeRange && formSearch.responseCreateTimeRange[0]"
            >
              <span>{{dateFtt('yyyy-MM-dd hh:mm:ss',formSearch.responseCreateTimeRange[0])}}</span>
              <br />
              <span style="margin-left:50%">~</span>
              <br />
              <span>{{dateFtt('yyyy-MM-dd hh:mm:ss',formSearch.responseCreateTimeRange[1])}}</span>
            </div>
            <DatePicker
              v-model="formSearch.responseCreateTimeRange"
              type="datetimerange"
              split-panels
              placeholder="请输入反馈时间..."
              :options="datePickerOptions"
              style="width:248px;"
            ></DatePicker>
          </Tooltip>
        </FormItem>
        <FormItem label="反馈状态：">
          <Select v-model="formSearch.responseState" clearable placeholder="请输入反馈状态...">
            <Option value="0">未处理</Option>
            <Option value="1">处理中</Option>
            <Option value="2">处理完成</Option>
          </Select>
        </FormItem>
        <FormItem label="反馈处理方式：">
          <Input v-model="formSearch.responseHandle" placeholder="请输入反馈处理方式..."></Input>
        </FormItem>
        <FormItem label="处理人：">
          <Input v-model="formSearch.responseHandlePersonnel" placeholder="请输入处理人..."></Input>
        </FormItem>
        <FormItem label="处理时间：">
          <Tooltip
            transfer
            placement="top"
            :disabled="formSearch.responseHandleTimeRange == undefined || formSearch.responseHandleTimeRange[0] == ''"
          >
            <div
              slot="content"
              v-if="formSearch.responseHandleTimeRange && formSearch.responseHandleTimeRange[0]"
            >
              <span>{{dateFtt('yyyy-MM-dd hh:mm:ss',formSearch.responseHandleTimeRange[0])}}</span>
              <br />
              <span style="margin-left:50%">~</span>
              <br />
              <span>{{dateFtt('yyyy-MM-dd hh:mm:ss',formSearch.responseHandleTimeRange[1])}}</span>
            </div>
            <DatePicker
              v-model="formSearch.responseHandleTimeRange"
              type="datetimerange"
              split-panels
              placeholder="请输入反馈时间..."
              :options="datePickerOptions"
              style="width:248px;"
            ></DatePicker>
          </Tooltip>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" size="large" long :loading="isLoadingButton" @click="commitSearch">查询</Button>
      </div>
    </Modal>

    <!-- 模态框Insert -->
    <Modal v-model="isShowModal.insert" :mask-closable="false" width="380">
      <p slot="header" style="color:#19be6b;text-align:center">
        <Icon type="md-create" />
        <span>添加反馈</span>
      </p>
      <Form ref="formInsert" :label-width="100" :model="formInsert" :rules="insertRule">
        <FormItem prop="responseType" label="反馈类型：">
          <Select v-model="formInsert.responseType" clearable placeholder="请选择反馈类型...">
            <Option value="申述">申述</Option>
            <Option value="咨询">咨询</Option>
            <Option value="建议">建议</Option>
            <Option value="报修">报修</Option>
          </Select>
        </FormItem>
        <FormItem prop="responseMeterId" label="设备编号：">
          <Select
            v-model="formInsert.viewCustomerInfo"
            filterable
            remote
            :remote-method="remoteCustomSearch"
            :loading="loadingRemote"
            clearable
            placeholder="请输入设备编号或用户姓名..."
            @on-change="onChangeRemote"
          >
            <Option
              v-for="option in optionList"
              :value="JSON.stringify(option)"
              :label="option.meterId"
              :key="JSON.stringify(option)"
            >{{option.meterId}}|{{option.customerName}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="responseCustomerName" label="用户姓名：">
          <Input v-model="formInsert.responseCustomerName" disabled placeholder="请输入用户姓名..."></Input>
        </FormItem>
        <FormItem prop="responseCustomerPhone" label="手机号：">
          <Input v-model="formInsert.responseCustomerPhone" disabled placeholder="请输入手机号..."></Input>
        </FormItem>
        <FormItem prop="responseCustomerAddress" label="地址：">
          <Input v-model="formInsert.responseCustomerAddress" disabled placeholder="请输入地址..."></Input>
        </FormItem>
        <FormItem prop="responseContent" label="反馈内容：">
          <Input
            v-model="formInsert.responseContent"
            placeholder="请输入反馈内容..."
            type="textarea"
            :autosize="{minRows: 2,maxRows: 5}"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="success" size="large" long :loading="isLoadingButton" @click="commitInsert">添加</Button>
      </div>
    </Modal>

    <!-- 模态框update -->
    <Modal v-model="isShowModal.update" :mask-closable="false" width="380">
      <p slot="header" style="color:#ff9900;text-align:center">
        <Icon type="md-create" />
        <span>处理反馈</span>
      </p>
      <Form ref="formUpdate" :label-width="100" :model="formUpdate" :rules="updateRule">
        <FormItem prop="responseState" label="反馈状态：">
          <Select v-model="formUpdate.responseState" placeholder="请选择反馈状态...">
            <Option value="1">处理中</Option>
            <Option value="2">处理完成</Option>
          </Select>
        </FormItem>
        <FormItem prop="responseHandle" label="处理方式：">
          <Input v-model="formUpdate.responseHandle" placeholder="请输入处理方式..."></Input>
        </FormItem>
        <FormItem prop="responseHandlePersonnel" label="处理人：">
          <Input v-model="formUpdate.responseHandlePersonnel" readonly placeholder="请输入处理人..."></Input>
        </FormItem>
        <FormItem prop="responseHandleTime" label="处理时间：">
          <Tooltip
            placement="top"
            :readonly="formUpdate.responseHandleTime == undefined || formUpdate.responseHandleTime == ''"
            transfer
            :content="
                (()=>{
                  if(formUpdate.responseHandleTime != undefined && formUpdate.responseHandleTime != ''){
                    
                    return dateFtt('yyyy-MM-dd hh:mm:ss', new Date(formUpdate.responseHandleTime));
                  }
                })()
                "
          >
            <DatePicker
              v-model="formUpdate.responseHandleTime"
              type="datetime"
              format="yyyy-MM-dd hh:mm:ss"
              placeholder="请输入处理时间..."
              disabled
              style="width:248px;"
            ></DatePicker>
          </Tooltip>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="warning" size="large" long :loading="isLoadingButton" @click="commitUpdate">处理</Button>
      </div>
    </Modal>

    <!-- 模态框delete -->
    <Modal v-model="isShowModal.delete" :mask-closable="false" width="380">
      <p slot="header" style="color:#ed4014;text-align:center">
        <Icon type="md-create" />
        <span>删除反馈</span>
      </p>
      <div style="color:#ed4014;text-align:center">确认删除当前选中数据？</div>
      <div slot="footer">
        <Button type="error" size="large" long :loading="isLoadingButton" @click="commitDelete">删除</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "customer_response",
  created() {
    this.showPage();
  },
  data() {
    return {
      tWidth: document.body.clientWidth * 0.8,
      isShowModal: {
        search: false,
        insert: false,
        update: false,
        delete: false
      },
      loadingRemote: false,
      isLoadingButton: false,
      isSpinShow: false,
      currentPage: 1,
      dataCount: 0,
      pageSize: 10,
      showData: [],
      showColumns: [
        {
          title: "反馈编号",
          key: "responseId",
          width: 95
        },
        {
          title: "反馈类型",
          key: "responseType",
          width: 85
        },
        {
          title: "设备编号",
          key: "responseMeterId",
          width: 135
        },
        {
          title: "用户姓名",
          key: "responseCustomerName",
          width: 100
        },
        {
          title: "手机号",
          key: "responseCustomerPhone",
          width: 120
        },
        {
          title: "地址",
          key: "responseCustomerAddress",
          tooltip: true,
          width: 200
        },
        {
          title: "反馈内容",
          key: "responseContent",
          tooltip: true,
          width: 250
        },
        {
          title: "反馈时间",
          key: "responseCreateTime",
          width: 150,
          render: function(h, params) {
            return h(
              "div",
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(this.row.responseCreateTime)
              )
            ); /*这里的this.row能够获取当前行的数据*/
          }
        },
        {
          title: "反馈状态",
          key: "responseState",
          width: 85,
          render: function(h, params) {
            switch (this.row.responseState) {
              case 0:
                return h("div", "未处理");
                break;
              case 1:
                return h("div", "处理中");
                break;
              case 2:
                return h("div", "处理完成");
                break;
              default:
                return h("div", "未知状态");
                break;
            }
          }
        },
        {
          title: "反馈处理方式",
          key: "responseHandle",
          tooltip: true,
          width: 120
        },
        {
          title: "处理人",
          key: "responseHandlePersonnel",
          width: 85
        },
        {
          title: "处理时间",
          key: "responseHandleTime",
          width: 150,
          render: function(h, params) {
            return h(
              "div",
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(this.row.responseHandleTime)
              )
            ); /*这里的this.row能够获取当前行的数据*/
          }
        }
      ],
      datePickerOptions: {
        shortcuts: [
          {
            text: "近一周",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            }
          },
          {
            text: "近一月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            }
          },
          {
            text: "近三月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            }
          }
        ]
      },
      searchParam: {},
      currentTableRow: null,
      formSearch: {},
      formInsert: {
        responseType: "申述",
        responseMeterId: "",
        responseCustomerName: "",
        responseCustomerPhone: "",
        responseCustomerAddress: ""
      },
      insertRule: {
        responseType: [
          {
            required: true,
            message: "请选择反馈类型...",
            trigger: "change"
          }
        ],
        responseCustomerName: [
          {
            required: true,
            message: "请选择用户名...",
            trigger: "blur"
          }
        ],
        responseCustomerPhone: [
          {
            required: true,
            message: "请选择手机号...",
            trigger: "blur"
          }
        ],
        responseCustomerAddress: [
          {
            required: true,
            message: "请选择地址...",
            trigger: "blur"
          }
        ],
        responseContent: [
          {
            required: true,
            message: "请选择反馈内容...",
            trigger: "blur"
          }
        ]
      },
      formUpdate: {
        responseState: "",
        responseHandle: "",
        responseHandlePersonnel: "",
        responseHandleTime: ""
      },
      updateRule: {
        responseState: [
          {
            required: true,
            message: "请选择反馈状态...",
            trigger: "change"
          }
        ],
        responseHandle: [
          {
            required: true,
            message: "请输入处理类型...",
            trigger: "blur"
          }
        ],
        responseHandlePersonnel: [
          {
            required: true,
            message: "请输入处理人...",
            trigger: "change"
          }
        ]
      },
      formDelete: {},
      optionList: []
    };
  },
  methods: {
    dateFtt(fmt, date) {
      return global.dateFtt(fmt, date);
    },
    changePage(index) {
      this.currentPage = index;
      this.showPage();
    },
    changePageSize(size) {
      this.pageSize = size;
      this.showPage();
    },
    showPage() {
      var that = this;
      that.isSpinShow = true;
      $.ajax({
        url:
          "/api/response/selectPage?page=" +
          this.currentPage +
          "&pageAmount=" +
          this.pageSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.searchParam),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.showData = data.body.resultList;
          that.dataCount = data.body.amount;
          that.isSpinShow = false;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    onClickSearch() {
      this.isShowModal.search = true;
    },
    onClickInsert() {
      this.isShowModal.insert = true;
    },
    onClickUpdate() {
      if (this.currentTableRow != null) {
        this.isShowModal.update = true;
        var that = this;
        that.isLoadingButton = true;
        that.formUpdate.responseHandlePersonnel = localStorage.getItem(
          "userName"
        );
        that.formUpdate.responseHandleTime = global.dateFtt(
          "yyyy-MM-dd hh:mm:ss",
          new Date()
        );
      } else {
        this.$Notice.error({
          title: "警告",
          desc: "请选择一条数据！"
        });
      }
    },
    onClickDelete() {
      if (this.currentTableRow != null) {
        this.isShowModal.delete = true;
      } else {
        this.$Notice.error({
          title: "警告",
          desc: "请选择一条数据！"
        });
      }
    },
    onTableCurrentChange(currentRow, oldCurrentRow) {
      this.currentTableRow = currentRow;
    },
    commitSearch() {
      this.searchParam = this.formSearch;
      this.isShowModal.search = false;
      this.showPage();
    },
    commitInsert() {
      var that = this;
      that.$refs["formInsert"].validate(valid => {
        if (valid) {
          var insertCondition = that.formInsert;
          insertCondition["responseState"] = 0;
          that.isLoadingButton = true;
          $.ajax({
            url: "/api/response/insert",
            contentType: "application/json",
            type: "post",
            data: JSON.stringify(insertCondition),
            dataType: "json",
            success: function(data) {
              if (data.errorCode != 0) {
                that.$Notice.error({
                  title: "异常",
                  desc: data.errorInfo
                });
                that.isLoadingButton = false;
                that.isShowModal.insert = false;
                return;
              }
              that.isLoadingButton = false;
              that.isShowModal.insert = false;
              that.$Notice.success({
                title: "添加成功！"
              });
              that.showPage();
            },
            error: function(textStatus) {
              that.$Notice.error({
                title: "异常",
                desc: "接口请求异常"
              });
            }
          });
        }
      });
    },
    commitUpdate() {
      var that = this;
      that.$refs["formUpdate"].validate(valid => {
        if (valid) {
          var updateCondition = that.formUpdate;
          updateCondition["responseId"] = that.currentTableRow.responseId;
          that.isLoadingButton = true;
          $.ajax({
            url: "/api/response/update",
            contentType: "application/json",
            type: "post",
            data: JSON.stringify(updateCondition),
            dataType: "json",
            success: function(data) {
              if (data.errorCode != 0) {
                that.$Notice.error({
                  title: "异常",
                  desc: data.errorInfo
                });
                that.isLoadingButton = false;
                that.isShowModal.update = false;
                return;
              }
              that.isLoadingButton = false;
              that.isShowModal.update = false;
              that.$Notice.success({
                title: "处理成功！"
              });
              that.showPage();
            },
            error: function(textStatus) {
              that.$Notice.error({
                title: "异常",
                desc: "接口请求异常"
              });
            }
          });
        }
      });
    },
    commitDelete() {
      var that = this;
      var deleteCondition = {};
      deleteCondition["responseId"] = that.currentTableRow.responseId;
      that.isLoadingButton = true;
      $.ajax({
        url: "/api/response/delete",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(deleteCondition),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            that.isLoadingButton = false;
            that.isShowModal.delete = false;
            return;
          }
          that.isLoadingButton = false;
          that.isShowModal.delete = false;
          that.$Notice.success({
            title: "删除成功！"
          });
          that.showPage();
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    //下拉框内容远程搜索
    remoteCustomSearch(param) {
      var that = this;
      clearTimeout(that.timer);
      that.timer = setTimeout(function() {
        that.loadingRemote = true;
        $.ajax({
          url:
            "/api/baseInfo/getViewCustomerDetailedPage?page=1&pageAmount=100",
          contentType: "application/json",
          type: "post",
          dataType: "json",
          data: JSON.stringify({
            customerNameOrMeter: param
          }),
          success: function(data) {
            if (data.errorCode != 0) {
              that.$Notice.error({
                title: "异常",
                desc: data.errorInfo
              });
              return;
            }
            that.optionList = data.body.resultList;
            that.loadingRemote = false;
          },
          error: function(textStatus) {
            that.$Notice.error({
              title: "异常",
              desc: "接口请求异常"
            });
          }
        });
      }, 1000);
    },
    //下拉框远程修改时间响应
    onChangeRemote(param) {
      if (this.formInsert.viewCustomerInfo && param && param != "") {
        var viewCustomerInfoObject = JSON.parse(
          this.formInsert.viewCustomerInfo
        );
        this.formInsert.responseMeterId = viewCustomerInfoObject.meterId;
        this.formInsert.responseCustomerName =
          viewCustomerInfoObject.customerName;
        this.formInsert.responseCustomerPhone =
          viewCustomerInfoObject.customerPhone;
        this.formInsert.responseCustomerAddress =
          viewCustomerInfoObject.addressLowestLevelAddressIds;
      } else {
        this.formInsert.responseMeterId = "";
        this.formInsert.responseCustomerName = "";
        this.formInsert.responseCustomerPhone = "";
        this.formInsert.responseCustomerAddress = "";
      }
    }
  }
};
</script>

<style scoped>
#responseTable /deep/ .ivu-table td,
#responseTable /deep/ .ivu-table th {
  min-width: 0;
  height: 30px;
  box-sizing: border-box;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  border-bottom: 1px solid #e8eaec;
}
</style>
